import client from "@/api";
import axios from "axios";

export default {
    login(username: string, password: string): Promise<account.TCurrent> {
        return client.post({
            url: "/common/auth/api/login",
            data: { userName: username, password },
        });
    },

    eumLogin(username: string, password: string, logonType: string): Promise<account.TCurrent> {
        return client.post({
            url: "/common/auth/api/eumLogin",
            data: { userName: username, password, logonType: logonType },
        });
    },

    loginex(username: string): Promise<account.TCurrent> {
        return client.post({
            url: "/common/auth/api/loginex",
            data: { username },
        });
    },

    loginHint(loginHint: string): Promise<account.TCurrent> {
        return client.post({
            url: "/common/auth/api/loginHint",
            data: { username: loginHint },
        });
    },

    loginAssertion(tenantId: string, idToken: string): Promise<account.TCurrent> {
        return client.post({
            url: "/common/EntraId/api/LoginWithIdToken",
            data: { tenantId: tenantId, idToken: idToken },
        });
    },

    logout(): Promise<void> {
        // logout은 api의 ResponseWrapper에 의해 정제된 데이터가 아니므로 HTTP 사용
        return client.get({ url: "/common/auth/api/logout" });
    },

    adfsLogout(): Promise<account.AdfsLogoutResponse> {
        return axios.get("/cm/common/Adfs/api/logout").then((res) => {
            return res.data as account.AdfsLogoutResponse;
        });
    },

    entraIDLogoutUrl(returnUrl: string): Promise<string> {
        return client.get({
            url: `/common/entraid/api/logouturl?returnUrl=${returnUrl}`,
        });
    },

    getLogonType(): Promise<string> {
        return client.get({
            url: "/common/auth/api/logonType",
        });
    },

    getIdentityAzureInfo(): Promise<account.IdentityAzureInfo> {
        return client.get({
            url: "/common/EntraId/api/identityAzureInfo",
        });
    },

    setAccessTokenByIdToken(idToken: string): Promise<boolean> {
        return client.post({
            url: "/common/EntraId/api/setAccessTokenByIdToken",
            data: { idToken: idToken },
        });
    },
};
